//utils/imageLoader.js
import imageConfig from '../config/json/imageConfig.json';

export const getImagePaths = (category) => {
  return imageConfig[category] ? Object.values(imageConfig[category]) : [];
};

export const getCategoryTitle = (category) => {
  return imageConfig.categories?.[category] || category;
};

//Helper function to load a single image
export const loadSingleImage = async (path) => {
  try {
    const module = await import(/*webpackMode: "eager"*/ `../${path}`);
    return module.default;
  } catch (error) {
    console.error(`Failed to load image: ${path}`, error);
    throw error;
  }
};

//For dynamic imports of image arrays
export const loadImages = async (category) => {
  if (!imageConfig[category]) return [];
  
  const imageModules = await Promise.all(
    Object.values(imageConfig[category]).map(path => 
      loadSingleImage(path).catch(error => {
        console.error(`Failed to load image: ${path}`, error);
        return null;
      })
    )
  );
  
  return imageModules.filter(Boolean);
};

//For loading code projects with their metadata
export const loadCodeProjects = async () => {
  try {
    const codeProjects = imageConfig.code;
    const projects = [];
    
    for (const [key, project] of Object.entries(codeProjects)) {
      try {
        //Handle both string paths and project objects
        if (typeof project === 'string') {
          //If it's just a string path, create a basic project object
          const imageSrc = await loadSingleImage(project);
          projects.push({
            id: key,
            src: imageSrc,
            url: `#`, //Default fallback URL
            title: key,
            alt: `Project ${key}`
          });
        } else if (project.image) {
          //If it's a project object with image property
          const imageSrc = await loadSingleImage(project.image);
          projects.push({
            id: key,
            src: imageSrc,
            url: project.url || `#`,
            title: project.title || key,
            alt: project.alt || project.title || `Project ${key}`
          });
        }
      } catch (error) {
        console.warn(`Failed to load image for project ${key}:`, error);
      }
    }
    
    return projects;
  } catch (error) {
    console.error('Error loading code projects:', error);
    return [];
  }
};